import { createSlice } from '@reduxjs/toolkit';
import { generateReduxKeys } from '../../utils';

const initialState = generateReduxKeys({
    hasSingleCustomer: false,
    details: null,
    balance: null,
    specialPrices: [],
    suggestedPrices: [],
    purchaseItems: [],
    potentialPurchaseItems: [],
    potentialPurchasePagination: {
        page: 1,
        total: 0,
        totalPages: 0,
    },
    potentialPurchaseLoading: false,
    notes: [],
    exclusionProducts: [],
    preferredProducts: [],
});

const customersSlice = createSlice({
    name: 'customers',
    initialState,
    reducers: {
        setHasSingleCustomer: (state, action) => {
            state.hasSingleCustomer = action.payload;
        },
        setCustomerDetails: (state, action) => {
            state.details = action.payload;
        },
        setCustomerBalance: (state, action) => {
            state.balance = action.payload;
        },
        setCustomerSpecialPrices: (state, action) => {
            state.specialPrices = action.payload;
        },
        setCustomerSuggestedPrices: (state, action) => {
            state.suggestedPrices = action.payload;
        },
        setCustomerPurchaseItems: (state, action) => {
            state.purchaseItems = action.payload;
        },
        setCustomerPotentialPurchaseItems: (state, action) => {
            state.potentialPurchaseItems = action.payload;
        },
        appendCustomerPotentialPurchaseItems: (state, action) => {
            state.potentialPurchaseItems = [...state.potentialPurchaseItems, ...action.payload];
        },
        setPotentialPurchasePagination: (state, action) => {
            state.potentialPurchasePagination = action.payload;
        },
        setCustomerNotes: (state, action) => {
            state.notes = action.payload;
        },
        setCustomerExclusionProducts: (state, action) => {
            state.exclusionProducts = action.payload;
        },
        setCustomerPreferredProducts: (state, action) => {
            state.preferredProducts = action.payload;
        },
        setPotentialPurchaseLoading: (state, action) => {
            state.potentialPurchaseLoading = action.payload;
        },
    },
});

export const {
    setHasSingleCustomer,
    setCustomerDetails,
    setCustomerBalance,
    setCustomerSpecialPrices,
    setCustomerSuggestedPrices,
    setCustomerPurchaseItems,
    setCustomerPotentialPurchaseItems,
    appendCustomerPotentialPurchaseItems,
    setPotentialPurchasePagination,
    setCustomerNotes,
    setCustomerExclusionProducts,
    setCustomerPreferredProducts,
    setPotentialPurchaseLoading,
} = customersSlice.actions;
export default customersSlice.reducer;
